var React = require('react');

function ContentCellphone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M384,0H48C21.5,0,0,21.5,0,48V672c0,26.5,21.5,48,48,48H384c26.5,0,48-21.5,48-48V48c0-26.5-21.5-48-48-48Zm24,672c0,13.2-10.8,24-24,24H48c-13.2,0-24-10.8-24-24V48c0-13.2,10.8-24,24-24H384c13.2,0,24,10.8,24,24V672ZM372,72H60c-6.6,0-12,5.4-12,12v504c0,6.6,5.4,12,12,12H372c6.6,0,12-5.4,12-12V84c0-6.6-5.4-12-12-12Zm-12,504H72V96H360v480Zm-84,72c0,6.6-5.4,12-12,12h-96c-6.6,0-12-5.4-12-12s5.4-12,12-12h96c6.6,0,12,5.4,12,12Z"}));
}

ContentCellphone.defaultProps = {"id":"uuid-ed0869e8-a629-4c8a-a6f6-0c06ff03edf0","data-name":"Layer 1","viewBox":"0 0 432 720"};

module.exports = ContentCellphone;

ContentCellphone.default = ContentCellphone;
